module.exports = __webpack_public_path__ + "assets/img/block-left-fca353ab.png";